import { Component, Inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RekbotNote } from '../../rekbots/rekbot-layout/rekbot-layout-models/rekbot-note.model';
import { RekbotNotesService } from '../../services/rekbots-notes.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RekbotViewNoteComponent } from "../../rekbots/rekbot-layout/rekbot-notes/rekbot-view-note/rekbot-view-note.component";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-modal-confirm-delete-note',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIcon,
    RouterLink
],
  templateUrl: './modal-confirm-delete-note.component.html',
  styleUrl: './modal-confirm-delete-note.component.css'
})
export class ModalConfirmDeleteNoteComponent {

  note!: RekbotNote;
  rekbotSerial!: string;

  constructor(
    private rekbotNotesService: RekbotNotesService,
    private dialogRef: MatDialogRef<ModalConfirmDeleteNoteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.note = this.data.note;
    this.rekbotSerial = this.data.rekbotSerial;
  }

  onConfirmDelete() {
    // Tutaj możesz dodać logikę usuwania notatki, np. wywołanie serwisu
    console.log("Notatka do usunięcia:", this.note);
    this.rekbotNotesService.confirmDeleteNote(this.note.rekbot_id, this.note.id!)
      .subscribe({
        next: (res) => {
          console.log("Notatka usunięta pomyślnie", res);
          this.dialogRef.close(true);
        },
        error: err => {
          console.error("Błąd podczas usuwania notatki", err);
          this.dialogRef.close(false);
        }
      });

  }

  onCancel() {
    this.dialogRef.close(false);
  }
  
  getRekbotSerial(rekbotId: number): string {
    return `Rekbot #${rekbotId}`; // Przykładowa implementacja
  }
}
